export const caseTypes = {
    insurance: "insurance",
    valuation: "valuation",
};
